import { Fragment, useContext, useEffect, useState } from "react";
import Dropzone from "../../../../../../components/dropzone/dropzone";
import ProgressBarField from "../../../../../../components/progressBarField/progressBarField";
import { UploadProcessStatus } from "../../../../../../components/progressBarField/progressBarInfo/types/progressBarInfoProps";
import Table from "../../../../../../components/shared/table/table";
import { notifyError } from "../../../../../../components/snackbar/snackbar";
import { UploadProps } from "../types/uploadProps";
import { apiContext } from "../../../../../../contexts/apiContext";
import KrFormContext, { KrLandslideFormTypes, MonitoringAttachments, krFormTypes } from "../../../../../../contexts/krFormContext";
import { UploadRegistrationCardFileProps } from "../../../../../../services/uploadFilesService/types/uploadFilesServiceProps";
import { uploadRegistrationCardFile } from "../../../../../../services/uploadFilesService/uploadFilesService";
import { DropzoneProps } from "../../../../../../components/dropzone/types/dropzoneProps";
import { ProgressBarFieldProps } from "../../../../../../components/progressBarField/types/progressBarFieldProps";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import TableActions from "../../../../../../components/shared/table/tableActions/tableActions";
import { TableProps } from "../../../../../../components/shared/table/types/tableProps";
import { HeadersTable } from "../../../../../../helpers/featureTableConstruct";
import { MonitoringType } from "../../../types/krFormView";
import { getErrorMessage } from "../../../../../../helpers/errorHelper";

const UploadMonitoringAttachments = (props: UploadProps) => {
    const api = useContext(apiContext);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { krForm, setkrForm } = useContext(KrFormContext);
    const [uploadedImages, setUploadedImages] = useState<MonitoringAttachments[]>([]);
    const [readyUploadedFiles, setReadyUploadedFiles] = useState<MonitoringAttachments[]>([]);
    const [progress, setProgress] = useState<boolean>(false);
    const [tableData, setTableData] = useState<MonitoringAttachments[]>([]);

    const objectIdNum = (krForm as KrLandslideFormTypes).landslideAttributes?.numeR_IDENTYFIKACYJNY!;

    useEffect(() => {
        prepareTableData();

    // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [(krForm as KrLandslideFormTypes).landslideMonitoringAttachments, props.monitoringRec, readyUploadedFiles]);

    useEffect(() => {
        if (props.newReadyUploadedFiles) {
            setReadyUploadedFiles(props.newReadyUploadedFiles)
            if (props.setUploadedMonitoringAttachments) props.setUploadedMonitoringAttachments(props.newReadyUploadedFiles)
        }
        else setReadyUploadedFiles([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [props.newReadyUploadedFiles]);

    const getAttributes = (form: krFormTypes) => {
        return (form as KrLandslideFormTypes).landslideAttributes;
    }

    // File dropzone
    const handleConfirm = async (files: File[]) => {
        if (files.length > props.maxFileNumberForUpload) {
            notifyError( { message: `Próba dodania plików zakończona niepowodzeniem - maksymalna liczba wgrywanych plików to ${props.maxFileNumberForUpload}` }); 
        } else {
            var uploadedFiles: MonitoringAttachments[] = [];
            Promise.all(files.map(async (file, index: number) => {
                // Add file to progress list (uploadedFiles) with uniqe local id, set starting progress values
                var id = crypto.randomUUID();
                const uploadedFile = {
                    rodzaJ_ZALACZNIKA_MONIT_SID: props.monitoringType === MonitoringType.Documentation ? 1 : 2,
                    osuwiskO_GID: getAttributes(krForm)!.globalid,
                    details: {
                        localUUID: id,
                        pliK_NAZWA: file.name,
                        uploadPercent: 0,
                        currentUploadStatus: UploadProcessStatus.Uploading
                    }
                };
                uploadedFiles.push(uploadedFile);
                setUploadedImages([...uploadedFiles]);

                // Show progress bars
                if (!progress) setProgress(true);
                if (props.setDisableBtn) props.setDisableBtn(true);

                // Update progress values 
                const handleOnUploadProgress = (progressEvent: any) => {
                    var perc = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    uploadedFiles = uploadedFiles.map(current => current.details?.localUUID === id ? { ...current, details: {...current.details, uploadPercent: perc, currentUploadStatus: perc === 100 ? UploadProcessStatus.Saving : current.details?.currentUploadStatus} } : current);
                    setUploadedImages([...uploadedFiles]);
                }

                let uploadRegistrationCardFileProps: UploadRegistrationCardFileProps = {
                    file: file,
                    isLandslide: true,
                    idNum: objectIdNum,
                    waitingRoomGlobalId: krForm.waitingRoomGlobalId ? krForm.waitingRoomGlobalId : "",
                    idx: index,
                    apiBase: api.apiUrl + api.apiVersion,
                    handleOnUploadProgress: handleOnUploadProgress,
                    rasterType: "",
                    monitoringType: props.monitoringType!,
                    folder: "Monitoring"
                }

                // Upload files
                return uploadRegistrationCardFile(uploadRegistrationCardFileProps)
                .then((res: any) => {
                    uploadedFiles = uploadedFiles.map(current => current.details?.localUUID === id ? 
                        { ...current, 
                            fileNameModified: res[1], 
                            pliK_SCIEZKA: res[0], 
                            monitoringLocalUUID: props.monitoringRec?.localUUID, 
                            monitorinG_REJESTR_GID: props.monitoringRec?.globalid,
                            monitorinG_REJESTR_ID: props.monitoringRec?.id
                        } 
                            : current);
                    setUploadedImages(uploadedFiles);
                    setReadyUploadedFiles([...readyUploadedFiles, ...uploadedFiles]);
                    if (props.setUploadedMonitoringAttachments) props.setUploadedMonitoringAttachments([...readyUploadedFiles, ...uploadedFiles]);

                    setTimeout(() => {
                        // Hide progress bars
                        setProgress(false);
                        if (props.setDisableBtn) props.setDisableBtn(false);
                    }, 1000);
                })
                
            })).catch((ex) => {
                setProgress(false);
                const errMsg = getErrorMessage(ex, 'Próba dodania plików zakończona niepowodzeniem.');
                notifyError({ message: errMsg });
            })
        }
    }

    var fileDropzoneProps: DropzoneProps = {
        multiple: true,
        disabled: progress,
        acceptedFiles: props.acceptedFiles,
        onConfirm: handleConfirm,
        acceptedFilesForSnackbar: props.acceptedFilesForSnackbar,
        dropzoneText: props.dropzoneText
    }

    // Progress bars
    const getProgressBarFieldProps = (currentPercentage: number, uploadProcessStatus: UploadProcessStatus, fileName: string): ProgressBarFieldProps => {
        return {
            progressBarInfoProps: {
                currentPercentage: currentPercentage,
                fileName: fileName,
                uploadProcessStatus: uploadProcessStatus
            },
            progressBarProps: {
                currentPercentage: currentPercentage
            }
        }
    }

    // File table
    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"rasters"}
            deleteClickHandler={handleDeleteClick}
            notEdit={true}
        />)
    }

    const handleDeleteClick = (row: any) => {
        if (!progress) {
            props.clickRowHandler(row);
            props.confirmationToggle(true);
        }
    }

    let headers = {
        pliK_NAZWA: "Nazwa pliku",
        nameRodzaj: "Rodzaj"
    };

    const appendMonitoringAttachmentsAttributes = (attributes: MonitoringAttachments[] | undefined) => {
        var data: MonitoringAttachments[] = [];
        attributes?.forEach((element) => {
            element.nameRodzaj = (element.rodzaJ_ZALACZNIKA_MONIT_SID === 1) ? MonitoringType.Documentation : MonitoringType.Raports;
            element.pliK_NAZWA = element.globalid ? getFileNameFromPath(element.pliK_SCIEZKA): element.details?.pliK_NAZWA;
            data.push(element);
        });
        return data;
    }

    const prepareTableData = () => {
        var data: MonitoringAttachments[] = appendMonitoringAttachmentsAttributes(readyUploadedFiles.concat((krForm as KrLandslideFormTypes).landslideMonitoringAttachments!)).filter(
            item => checkAttachmentsByExistingMainKey(item));
        setTableData(data);
    }

    const checkAttachmentsByExistingMainKey = (att: MonitoringAttachments) => {
        if (props.monitoringRec) {
            return att.monitorinG_REJESTR_GID === props.monitoringRec.globalid;
        }
    }
    
    const getFileNameFromPath = (str: string | undefined) => {
        if (str) return str.split('\\').pop()!.split('/').pop();
        else return undefined;
    }

    var tablePropsMonitoringAttachmentsTable: TableProps = {
        columnAliases: headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: Object.keys(headers),
        cellActions: cellAction,
        data: tableData,
        loading: false,
        className: "fileTable",
        foldoutRows: false,
        refocus: props.refocus,
        setRefocusTable: props.setRefocusTable
    }

    return (
        <>
            <Dropzone {...fileDropzoneProps} /> <br />
            {progress && uploadedImages.map(item => (
                <Fragment key={item.details?.localUUID}>
                    <ProgressBarField {...getProgressBarFieldProps(item.details!.uploadPercent!, item.details!.currentUploadStatus!, item.details!.pliK_NAZWA!)} />
                    <br />
                </Fragment>
            ))}
            <br /><br />
            <Table {...tablePropsMonitoringAttachmentsTable} /> <br />
        </>
    )
}

export default UploadMonitoringAttachments;